import { format, parseISO, subDays } from 'date-fns';
import { API_DATE_FORMAT } from '../../../utils';
export const subsHalfCalendarDaysCount = (segment, calendarDaysCount) => {
    const daysOffset = Math.floor(calendarDaysCount / 2);
    return Object.assign(Object.assign({}, segment), { date: format(subDays(parseISO(segment.date), daysOffset), API_DATE_FORMAT) });
};
export const getSelectedFarePrice = (fare, legIndex, useActualizedOrderFlightPrices, flightSegmentGroups) => {
    var _a;
    const selectedPrice = (_a = fare.prices) === null || _a === void 0 ? void 0 : _a.find(price => { var _a, _b; return ((_a = price.flight) === null || _a === void 0 ? void 0 : _a.id) === ((_b = fare.flightInfo) === null || _b === void 0 ? void 0 : _b.id); });
    const actualizedSegmentGroup = flightSegmentGroups === null || flightSegmentGroups === void 0 ? void 0 : flightSegmentGroups[legIndex];
    const price = useActualizedOrderFlightPrices && (actualizedSegmentGroup === null || actualizedSegmentGroup === void 0 ? void 0 : actualizedSegmentGroup.price)
        ? actualizedSegmentGroup.price
        : selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.price;
    return {
        price,
        priceInMiles: selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.priceInMiles
    };
};
